import { render, staticRenderFns } from "./adminpercentage.vue?vue&type=template&id=1c50f637&scoped=true"
import script from "./adminpercentage.vue?vue&type=script&lang=js"
export * from "./adminpercentage.vue?vue&type=script&lang=js"
import style0 from "./adminpercentage.vue?vue&type=style&index=0&id=1c50f637&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c50f637",
  null
  
)

export default component.exports